var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "col"
  }, [_c("div", {
    staticClass: "menu-item shadow p-4 rounded text-center d-flex flex-column",
    style: {
      "--icon-color": _vm.iconColor,
      "--hover-color": _vm.hoverColor
    }
  }, [_c("router-link", {
    staticClass: "text-decoration-none h-100 d-flex flex-column justify-content-between align-items-center",
    attrs: {
      to: _vm.path
    }
  }, [_c("div", {
    staticClass: "icon-wrapper mb-3"
  }, [_c("i", {
    staticClass: "icon",
    class: _vm.icon
  })]), _vm._v(" "), _c("figcaption", {
    staticClass: "figure-caption fw-bold text-center",
    domProps: {
      innerHTML: _vm._s(_vm.caption)
    }
  })])], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };